class NumberOrNullOrUndefinedClass {
  value: unknown;

  constructor(value?: unknown) {
    this.value = value;
  }

  static from<T>(value?: T): number | undefined {
    return value === undefined
      ? undefined
      : value === null
      ? undefined
      : Number(value);
  }
}

// Declarar la interfaz y el constructor
interface NumberOrNullOrUndefinedConstructor {
  new (value?: unknown): NumberOrNullOrUndefinedClass;
  (value?: unknown): number | undefined;
  readonly prototype: NumberOrNullOrUndefinedClass;
}

const NumberOrNullOrUndefinedFunction = function (
  this: unknown,
  value?: unknown
) {
  if (this instanceof NumberOrNullOrUndefinedFunction) {
    return new NumberOrNullOrUndefinedClass(value);
  } else {
    return NumberOrNullOrUndefinedClass.from(value);
  }
};

NumberOrNullOrUndefinedFunction.prototype =
  NumberOrNullOrUndefinedClass.prototype;
export const NumberOrNullOrUndefined: NumberOrNullOrUndefinedConstructor =
  NumberOrNullOrUndefinedFunction as NumberOrNullOrUndefinedConstructor;
